import { Stack, Typography } from "@mui/material";

export default function DesignGuidelines() {
  return (
    <>
      <Stack p={8} spacing={2}>
        <Typography color="#E94F37" variant="h3" fontWeight="bold">
          Onze ontwerprichtlijnen
        </Typography>

        <Typography width={700} fontSize="18px" color="#888">
          Aan de hand van de inzichten uit ons onderzoek, hebben wij ontwerprichtlijnen opgesteld.
          Deze richtlijnen helpen ons bij het verzinnen van een passend concept voor ons
          ontwerpdoel.
        </Typography>
      </Stack>

      <Stack direction="row" spacing={3} justifyContent="center" pb={8}>
        <img
          src={require("../Assets/Images/ontwerp1.png")}
          alt="ontwerp1"
          style={{ width: "20%" }}
        />
        <img
          src={require("../Assets/Images/ontwerp2.png")}
          alt="ontwerp2"
          style={{ width: "20%" }}
        />
        <img
          src={require("../Assets/Images/ontwerp3.png")}
          alt="ontwerp3"
          style={{ width: "20%" }}
        />
        <img
          src={require("../Assets/Images/ontwerp4.png")}
          alt="ontwerp4"
          style={{ width: "20%" }}
        />
      </Stack>
    </>
  );
}
